import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Like from './like/Like';

const PF = 'https://ecommerce-api-l3as.onrender.com/images/';

const ProductPanel = ({ product, handleAddCart, handleAddFav, grid = true }) => {
  if (grid) {
    return (
      <article className="group p-3 bg-white rounded-xl shadow border border-gray-500 border-opacity-30">
        <div className="relative flex justify-center h-48 rounded ">
          <div className="text-xl absolute -top-2 -right-2 cursor-pointer opacity-0 group-hover:opacity-100 transition-all duration-500 ease-in-out">
            <Like product={product} handleAddFav={handleAddFav} />
          </div>
          <img
            alt={product.title}
            className="max-h-full w-full rounded-lg flex-shrink-0 bg-black object-cover"
            src={product.img.startsWith('product') ? PF + product.img : product.img}
          />

          <div className="absolute -bottom-2 left-50 w-20 h-20 rounded transition-all duration-500 ease-in-out opacity-0 group-hover:opacity-100  flex justify-center items-center bg-opacity-30 cursor-pointer">
            <button
              className="px-5 py-3 text-white bg-blue-500 cursor-pointer"
              onClick={() => handleAddCart(product, product.color[0], product.size[0])}
            >
              <i className="text-2xl fa fa-shopping-bag"></i>
            </button>
            <Link to={`/products/${product._id}`} className="cursor-pointer  px-5 py-3  bg-white">
              <i className="text-2xl fa fa-share"></i>
            </Link>
          </div>
        </div>
        <footer className="flex gap-2 mt-4 capitalize">
          <h6 className="">{product.title}</h6>
          <p className="text-blue-500 tracking-widest font-bold text-xl">${product.price}</p>
        </footer>
      </article>
    );
  }

  return (
    <article className="flex flex-col lg:flex-row gap-4 lg:gap-8 mb-10 ">
      <div className="flex items-center justify-center relative h-48 w-10/12 md:w-7/12 lg:w-64 rounded p-3 bg-white shadow ">
        <img
          alt={product.title}
          className="max-h-full max-w-full rounded bg-black object-cover "
          src={product.img.startsWith('product') ? PF + product.img : product.img}
        />
      </div>
      <footer className="w-full lg:w-8/12 flex flex-col gap-3 justify-center capitalize">
        <div>
          <h4 className="font-bold">{product.title}</h4>
          <p className="text-blue-500 tracking-widest font-semibold">${product.price}</p>
        </div>
        <p>{product.desc}</p>
        <Link to={`/products/${product._id}`} className="btn bg-blue-500 text-white w-max text-xs">
          Details
        </Link>
      </footer>
    </article>
  );
};

ProductPanel.propTypes = {
  product: PropTypes.object.isRequired,
  grid: PropTypes.bool,
};

export default ProductPanel;
